module.exports={
	"Form": "PhysicalAssetElementTypeEditManifest",
	"Scope": "PhysicalAssetElementType-Edit",
	"Descriptors":
	{
		"PhysicalAssetElementTypeDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetElementType-Edit-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Identity",
				"Group": "PhysicalAssetElementType-Edit-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.SectionCode":
		{
			"Name": "Section Code",
			"Hash": "PhysicalAssetElementType-Edit-SectionCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Identity",
				"Group": "PhysicalAssetElementType-Edit-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetElementType-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 6,
				"Section": "PhysicalAssetElementType-Edit-Identity",
				"Group": "PhysicalAssetElementType-Edit-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Section":
		{
			"Name": "Section",
			"Hash": "PhysicalAssetElementType-Edit-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Details",
				"Group": "PhysicalAssetElementType-Edit-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Unit":
		{
			"Name": "Unit",
			"Hash": "PhysicalAssetElementType-Edit-Unit",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Details",
				"Group": "PhysicalAssetElementType-Edit-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Clarification":
		{
			"Name": "Clarification",
			"Hash": "PhysicalAssetElementType-Edit-Clarification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Details",
				"Group": "PhysicalAssetElementType-Edit-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetMaterial":
		{
			"Name": "Physical Asset Material",
			"Hash": "PhysicalAssetElementType-Edit-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-Details",
				"Group": "PhysicalAssetElementType-Edit-Details",
				"Entity": "PhysicalAssetMaterial",
				"SearchFields":
				[
					"Code",
					"Description"
				]
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetElementType":
		{
			"Name": "IDPhysical Asset Element Type",
			"Hash": "PhysicalAssetElementType-Edit-IDPhysicalAssetElementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.GUIDPhysicalAssetElementType":
		{
			"Name": "GUIDPhysical Asset Element Type",
			"Hash": "PhysicalAssetElementType-Edit-GUIDPhysicalAssetElementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetElementType-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetElementType-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetElementType-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetElementType-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-Edit-DataAudit",
				"Group": "PhysicalAssetElementType-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetElementType-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetElementType-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetElementType-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetElementType-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetElementType-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetElementType-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
